import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import {
  useNcmMutation,
  useReducedNcm,
} from '@/core/domain/operational/Ncm/Ncm.hooks';
import { ListNcmsQuery } from '@/core/domain/operational/Ncm/Ncm.types';
import useSelectOptions from '@/hooks/useSelectOptions';
import { removeTextMask } from '@/utils/mask/removeTextMask';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListNcmsQuery;
};

const NcmSelectField: React.FC<Props> = ({ queryFilter, ...props }) => {
  const [searchValue, setSearchValue] = useState<string>();
  const [selectClicked, setSelectClicked] = useState<boolean>(false);
  const search = useDebounce(searchValue);

  const ncmReducedList = useReducedNcm(
    {
      rows: 10,
      description: removeTextMask(search),
      ...queryFilter,
    },
    selectClicked && !props.disabled,
  );

  const ncmDetail = useNcmMutation();

  const ncmOptions = useSelectOptions({
    list: ncmReducedList,
    detail: ncmDetail,
    selectProps: props,
    labelFormatter: (ncm) => `${ncm.code} - ${ncm.description ?? ''}`,
  });

  const handleSelectClick = () => {
    if (!selectClicked) {
      setSelectClicked(true);
    }
  };

  return (
    <InfiniteSelect
      fetchNextPage={ncmReducedList.fetchNextPage}
      hasNextPage={ncmReducedList.hasNextPage}
      loading={ncmReducedList.isFetching}
      options={ncmOptions}
      showSearch
      searchValue={searchValue}
      onSelect={() => setSelectClicked(false)}
      filterOption={false}
      onSearch={setSearchValue}
      onClick={handleSelectClick}
      allowClear
      {...props}
    />
  );
};

export default NcmSelectField;
